import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';

export const designationdetails = createAsyncThunk(
  'designationdetails',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const Employee_Id = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const company_id = JSON.parse(
        localStorage.getItem('userData')
      )?.companyId;
      const res = await axios.get(`/DesignationList`, {
        params: { Employee_Id, company_id },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const hierarchyDropdownList = createAsyncThunk(
  'hierarchyDropdownList',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const Employee_Id = JSON.parse(
        localStorage.getItem('userData')
      )?.employeeId;
      const company_id = JSON.parse(
        localStorage.getItem('userData')
      )?.companyId;
      const res = await axios.get(`/HierarchyDropdown`, {
        params: { Employee_Id, company_id },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const STPFCReportDetails = createAsyncThunk(
  'STPFCReportDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/STPFCReport`, {
        params: data,
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error));
    }
  }
);

export const STPFCAdminReportDetails = createAsyncThunk(
  'STPFCAdminReportDetails',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/STPFCAdminReport`, {
        params: data,
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

const sfcReport = createSlice({
  name: 'sfcReport',
  initialState: {
    isLoading: false,
    desigdata: [],
    hierarchydropdown: [],
    sfcdetails: [],
    sfcadminreport: [],
    //Submitdata:[],
    successMessage: '',
    apiError: '',
  },
  reducers: {
    clearSfcReportData: (state) => {
      state.sfcdetails = [];
      state.sfcadminreport = [];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(designationdetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(designationdetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.desigdata = action.payload;
    });
    builder.addCase(designationdetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.desigdata = null;
    });

    builder.addCase(hierarchyDropdownList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(hierarchyDropdownList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.hierarchydropdown = action.payload;
    });
    builder.addCase(hierarchyDropdownList.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.hierarchydropdown = null;
    });

    builder.addCase(STPFCReportDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(STPFCReportDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.sfcdetails = action.payload;
    });
    builder.addCase(STPFCReportDetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.sfcdetails = null;
    });

    builder.addCase(STPFCAdminReportDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(STPFCAdminReportDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.sfcadminreport = action.payload;
    });
    builder.addCase(STPFCAdminReportDetails.rejected, (state, action) => {
      state.apiError = action.payload || 'Something went wrong';
      state.isLoading = false;
      state.sfcadminreport = null;
    });
  },
});
export const { clearSfcReportData } = sfcReport.actions;
export default sfcReport.reducer;
